export default "__VITE_ASSET__faafccec__"